import { IP2PMetadataEntity } from './interface-p2p-metadata-entity';
import { MetadataEntityBase } from './abstract-metadata-entity-base';

/**
 * ç¹å°ç¹åæ°æ®å®ä½æ½è±¡ç±»
 */
export abstract class P2PMetadataEntityBase extends MetadataEntityBase implements IP2PMetadataEntity {
    SourceAppCode: string;

    SourceSuCode: string;

    SourceBoId: string;

    SourceBeMetadataId: string;

    SourceBeId: string;

    SourceBeType: string;

    SourceVoMetadataId: string;

    SourceVoId: string;

    SourceVoType: string;

    TargetAppCode: string;

    TargetSuCode: string;

    TargetBoId: string;

    TargetBeMetadataId: string;

    TargetBeId: string;

    TargetBeType: string;

    TargetVoMetadataId: string;

    TargetVoId: string;

    TargetVoType: string;

    TargetVoProxyMetadataId: string;

    TargetVoProxyId: string;

    TargetVoProxyType: string;

}